import React ,{Component} from 'react';

import { BrowserRouter as Router, Route, HashRouter,Routes,NavLink, } from 'react-router-dom';
import './App.css';
import { Navigate  } from 'react-router-dom';
import './components/styles/styles.css';
import Formlayout from "./components/Formlayout";
import Addleadmaster from "./components/Addleadmaster";

import UserforgotPassword from "./components/UserforgotPassword";
import Freezingreport from "./components/Freezingreport";
import Groupweeklyclasses from "./components/Groupweeklyclasses";
import Trialclassreport from "./components/Trialclassreport";
import Adminleadmaster from "./components/Adminleadmaster";
import Layoutmenu from "./components/Layoutmenu";
import AppLayout from "./components/AppLayout";
import Branch from "./components/Branch";
import ApplyLeave from "./components/ApplyLeave";
import Approveleave from "./components/Approveleave";
import Adminstaff from "./components/Adminstaff";
import Addstaff from "./components/Addstaff";
import Default from "./components/Stafflogin";
import Staffchangepassword from "./components/Staffchangepassword";
import Admincustomer from "./components/Admincustomer";
import Addcustomer from "./components/Addcustomer";
import Slotmanagement from "./components/Slotmanagement";
import Subscription from "./components/Subscription";
import Leadmaster from "./components/Leadmaster";
import Leadstatus from "./components/Leadstatus";
import Customerlogin from "./components/Customerlogin";
import ScheduleCalender from "./components/ScheduleCalender";
import SchedulePopUp from "./components/SchedulePopUp";
import Addbanner from "./components/Addbanner";
import Orderdetails from "./components/Orderdetails";
import Leavesreport from "./components/Leavesreport";
import Adminorderreports from "./components/Adminorder-report";
import Adminfeedbackreport from "./components/Adminfeedbackreport";
import Leadmasterreport from "./components/Leadmasterreport";
import Customerchangepassword from "./components/Customerchangepassword";
import Adminpromotion from "./components/Adminpromotion";
import Addpromotion from "./components/Addpromotion";
import Admincms from "./components/Admincms";
import Addfeedback from "./components/Addfeedback";
import Adminfeedback from "./components/Adminfeedback";
import CustomerReview from "./components/CustomerReview";

import Holidaymanagement from "./components/Holidaymanagement";
import Noshowreport from "./components/No-showreport";
import Salesreport from "./components/Salesreport";
import Accountsreport from "./components/Accountsreport";
import Customerreport from "./components/Customerreport";
import Logout from "./components/Logout";
import Renewalreport from "./components/Renewalreport";
import Notificationreport from "./components/Notificationreport";
import Layoutcontent from "./components/Layoutcontent";
import Orderview from "./components/Orderview";
import Adminstrialclass from "./components/Adminstrialclass";
import ClientAttendreport from "./components/ClientAttendreport";

import Staffchecheckinreport from "./components/Staffchecheckinreport";
import Notificationcalendar from "./components/Notificationcalendar";
import Adminorder from "./components/Adminorder";
import Admincustomerpostponerequest from "./components/Admincustomerpostponerequest";

import StaffScheduleReport from "./components/StaffScheduleReport";
import Adminstaffschedule from "./components/Adminstaffschedule";
import Leadsfollowpop from "./components/Leadsfollowpop";
import Mapautocomplete from "./components/Mapautocomplete";
import ForgotPassword from "./components/ForgotPassword";
import Resetpassword from "./components/Resetpassword";
import LeadsFollowuplatestdate from './components/LeadsFollowuplatestdate';
import CustomerbyBranch from './components/CustomerbyBranch';
import CustomerattendenceReport from './components/CustomerattendenceReport';
	
	import Adminbilling from "./components/Adminbilling";
import Headinglayout from "./components/Headinglayout";
import './App.css';
import Registration from "./components/Regsitration";
import AppPayment from "./components/AppPayment";
class App extends Component {
render() {
    return ( 
	
	<Router basename="/">

	
	
	<Routes>
	 <Route path="/Registration" element={<Registration />} />
	  <Route path="/AppPayment" element={<AppPayment />} />
	 
	  <Route path="/UserforgotPassword" element={<UserforgotPassword />} />
	 <Route element={<Formlayout />}>
	 
	
	 		<Route path="/Default" element={<Default />} />
			<Route exact path="/"  element={<Navigate to="/Default" />}  />
			<Route path="/ForgotPassword" element={<ForgotPassword />} />
		
		<Route path="/Logout" element={<Logout />} />
		<Route path="/Resetpassword" element={<Resetpassword />} />
	 </Route>
		</Routes>
		
		<Routes>
	 <Route element={<AppLayout />}>
	 <Route path="/Branch" element={<Branch />} /> 
	  <Route path="/Accountsreport" element={<Accountsreport />} />
	  <Route path="/Noshowreport" element={<Noshowreport />} />
	  <Route path="/ClientAttendreport" element={<ClientAttendreport />} />
	  <Route path="/CustomerattendenceReport" element={<CustomerattendenceReport />} />
	  <Route path="/CustomerbyBranch" element={<CustomerbyBranch />} />
	 
	  <Route path="/Freezingreport" element={<Freezingreport />} />
	   <Route path="/Groupweeklyclasses" element={<Groupweeklyclasses />} />
	   <Route path="/Holidaymanagement" element={<Holidaymanagement />} />
	  <Route path="/Salesreport" element={<Salesreport />} />
	 <Route path="/Renewalreport" element={<Renewalreport />} /> 
	  <Route path="/Staffchecheckinreport" element={<Staffchecheckinreport />} /> 
	  <Route path="/Trialclassreport" element={<Trialclassreport />} /> 
	  <Route path="/Leadsfollowpop" element={<Leadsfollowpop />} /> 
	  <Route path="/Mapautocomplete" element={<Mapautocomplete />} /> 
	  <Route path="/Adminbilling" element={<Adminbilling />} /> 
	 <Route path="/Subscription" element={<Subscription />} /> 
	 <Route path="/Slotmanagement" element={<Slotmanagement />} /> 
	 	 <Route path="/Addcustomer" element={<Addcustomer />} /> 
		 <Route path="/Admincustomer" element={<Admincustomer />} />
		  <Route path="/Addpromotion" element={<Addpromotion />} />
<Route path="/Adminpromotion" element={<Adminpromotion />} /> 
	 <Route path="/Admincms" element={<Admincms />} />
	 <Route path="/Adminorder" element={<Adminorder />} />  	
	 	 <Route path="/Notificationcalendar" element={<Notificationcalendar />} />
	 <Route path="/Adminstaff" element={<Adminstaff />} />  
		 <Route path="/Orderview" element={<Orderview />} /> 
	<Route path="/Adminstaffschedule" element={<Adminstaffschedule />} />  	
<Route path="/Staffchangepassword" element={<Staffchangepassword />} />
	 <Route path="/Addstaff" element={<Addstaff />} />
 <Route path="/Adminfeedback" element={<Adminfeedback />} />
 
 <Route path="/Addbanner" element={<Addbanner />} />
  <Route path="/Orderdetails" element={<Orderdetails />} />
  <Route path="/Notificationreport" element={<Notificationreport />} />
<Route path="/Approveleave" element={<Approveleave />} /> 
 <Route path="/Adminleadmaster" element={<Adminleadmaster />} /> 
	
	 <Route path="/Customerreport" element={<Customerreport />} /> 
<Route path="/Admincustomerpostponerequest" element={<Admincustomerpostponerequest />} />	
<Route path="/StaffScheduleReport" element={<StaffScheduleReport />} />
<Route path="/Adminstrialclass" element={<Adminstrialclass />} />
<Route path="/Addleadmaster" element={<Addleadmaster />} />
	  
	  <Route path="/Leavesreport" element={<Leavesreport />} />
	  <Route path="/Adminorderreports" element={<Adminorderreports />} />
	 <Route path="/Adminfeedbackreport" element={<Adminfeedbackreport />} />
	 <Route path="/Leadmasterreport" element={<Leadmasterreport />} />
	   <Route path="/LeadsFollowuplatestdate" element={<LeadsFollowuplatestdate />} /> 
		</Route>
		</Routes>
		

	<Routes>

<Route path="/AppLayout" element={<AppLayout />} />  
 
	   <Route path="/ApplyLeave" element={<ApplyLeave />} />  
	 


<Route path="/Customerchangepassword" element={<Customerchangepassword />} />   




<Route path="/Leadmaster" element={<Leadmaster />} /> 
<Route path="/Leadstatus" element={<Leadstatus />} /> 

<Route path="/Customerlogin" element={<Customerlogin />} />  
<Route path="/ScheduleCalender" element={<ScheduleCalender />} />
<Route path="/SchedulePopUp" element={<SchedulePopUp />} />   
 


 


<Route path="/CustomerReview" element={<CustomerReview />} />  

	
	
	
	
  		
	

	   
	</Routes>
	
	  

	
	 </Router>
	
	
    );
  }
}


export default App;
